import { render, staticRenderFns } from "./MaterialsDocument.vue?vue&type=template&id=052063fb&scoped=true"
import script from "./MaterialsDocument.vue?vue&type=script&lang=js"
export * from "./MaterialsDocument.vue?vue&type=script&lang=js"
import style0 from "./MaterialsDocument.vue?vue&type=style&index=0&id=052063fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052063fb",
  null
  
)

export default component.exports